import { inventoryHint } from '../nbt/inventory';

export function InventoryHint({ block, compact = false }: { block: string; compact?: boolean }) {
  const hint = inventoryHint(block);
  return (
    <span className="inventory-hint">
      {hint.query && <span>検索する名前：<strong>{hint.query}</strong></span>}
      {(!compact || !hint.query || !hint.note.startsWith('クリエイティブ')) && <span>{hint.note}</span>}
    </span>
  );
}
